import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { normalizeEnterpriseAccountTier } from '#pplx/frontend/auth/subscriptionTier.js';
import { authClient } from '#pplx_generated/typespec/rest/auth/client.js';
export const getLinkedAccounts = async ({ reason, }) => {
    const { error, data, response } = await authClient.GET('/api/auth/linked-accounts', reason, {
        numRetries: 1,
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to get linked accounts',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data.accounts.map((account) => ({
        userId: account.user_id,
        email: account.email,
        displayName: account.display_name,
        avatarUrl: account.avatar_url,
        subscriptionTier: normalizeEnterpriseAccountTier(account.org_uuid, account.subscription_tier),
        orgUuid: account.org_uuid,
        isPrimary: account.is_primary,
    }));
};
//# sourceMappingURL=getLinkedAccounts.js.map